<template>
  <div>
    <!-- Alert - DESKTOP-->
    <div v-if="!($mq === 'mobile' || $mq === 'tablet') && !me.data.verified && $route.name !== 'Chat'" class="row px-4 py-1 alert-danger shadow-sm mb-2"
         style="margin-left: -25px; margin-right: -25px;">
      <div class="col-12 d-flex justify-content-between pb-2">
        <div class="d-flex align-content-center">
          <i class="bx bx-mail-send mt-1 mr-2"></i>
          <span>
            {{ getTranslations('expression_584') }} "<strong>{{ me.data.email }}</strong>"
          </span>
        </div>
        <div class="cursor_pointer">
          <small @click="resendEmail()">{{ getTranslations('expression_585') }}</small>
        </div>
      </div>
    </div>
    <!-- Alert - MOBILE-->
    <div v-if="($mq === 'mobile' || $mq === 'tablet') && !me.data.verified && $route.name !== 'Chat'" class="row px-2 py-1 alert-danger shadow-sm mb-2">
      <div class="col-12 pb-0 text-center"  style="font-size: .9rem;">
        <i class="bx bx-mail-send mt-1 mr-2"></i>
        <span>
          {{ getTranslations('expression_584') }} "<strong>{{ me.data.email }}</strong>"
        </span>
      </div>
      <div class="col-12 text-center pt-0">
        <div class="cursor_pointer">
          <small @click="resendEmail()">{{ getTranslations('expression_585') }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "AlertConfirmEmail",
  computed: {
    ...mapState(['configs', 'me']),
    ...mapGetters(['getTranslation'])
  },
  methods: {
    resendEmail() {
      this.$store.dispatch("confirmEmail", {email: this.me.data.email})
    }
  }
}
</script>

<style scoped>
.list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.list-group-item:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
